import React from 'react';
import { SimpleModal } from '@livable/saas-react-components';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import { ModalContent } from './modalContent';
export const PropertyDetailsModal = observer(_ref => {
  var _store$homeDashboardS;
  let isOpen = _ref.isOpen,
    handleClose = _ref.handleClose,
    triggerRefresh = _ref.triggerRefresh;
  const store = useStore();
  return /*#__PURE__*/React.createElement(SimpleModal, {
    noFooter: true,
    title: "Property information",
    subTitle: (_store$homeDashboardS = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS === void 0 || (_store$homeDashboardS = _store$homeDashboardS.propertyInformation) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.propertyAddress,
    trigger: null,
    noPadding: true,
    isOpen: isOpen,
    handleClose: handleClose
  }, /*#__PURE__*/React.createElement(ModalContent, {
    triggerRefresh: triggerRefresh,
    handleClose: handleClose
  }));
});